import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=a2460f7e&scoped=true"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&id=a2460f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2460f7e",
  null
  
)

export default component.exports